/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { ThemeName } from '@apitable/components';
import { store } from 'pc/store';

let preTheme: ThemeName;

store.subscribe(() => {
  const state = store.getState();
  const theme = state.theme;
  if (theme !== preTheme){
    preTheme = theme;
    const iframeList = Array.from(document.getElementsByTagName('iframe'));
    iframeList.forEach(v => {
      v.contentWindow?.postMessage({ type: 'apitable_theme', apitable_theme: theme }, '*');
    });
  }
});
